(function () {
    'use strict';
    var m = angular.module('profiles');
    m.factory('remediationActionsLogic', ["$routeParams", "widgetPolling", "objectTypeDao", "modals", "manualActionDao", "remediationProperties", "feature", "$q", "modulesDao", "appConfigurator", function ($routeParams, widgetPolling, objectTypeDao, modals, manualActionDao, remediationProperties, feature, $q, modulesDao, appConfigurator) {
        return function ($scope, logic) {
            var fileId = widgetPolling.scope().id;
            var objectTypes = widgetPolling.scope().objectTypes;
            var actionTypes = _(objectTypes.data.actionTypes[logic.entityType]).chain().map(function (action) {
                return [
                    action.id,
                    action
                ];
            }).object().value();
            _($scope.model.actions).each(function (action) {
                if (!action.actionType) {
                    return;
                }
                if (action.feature && !feature[action.feature]) {
                    return;
                }
                if (action.matchEntityType && (!actionTypes[action.actionType] || !_(actionTypes[action.actionType].entities).contains(logic.entityType))) {
                    return;
                }
                action.label = actionTypes[action.actionType] && actionTypes[action.actionType].label;
                action.label_disabled = actionTypes[action.actionType] && actionTypes[action.actionType].label_disabled;
                action.onClick = function () {
                    var actionType = actionTypes[action.actionType];
                    var p = $q.when();
                    if (actionType.required_config) {
                        var moduleConfig;
                        var moduleToConfigure = objectTypes.data.entities[logic.entityType] && objectTypes.data.entities[logic.entityType].saas;
                        if ($scope.model.entityData && $scope.model.entityData.moduleConfig) {
                            moduleConfig = $scope.model.entityData.moduleConfig;
                        } else {
                            if (moduleToConfigure) {
                                p = p.then(function () {
                                    return modulesDao.retrieveConfig(moduleToConfigure).then(function (response) {
                                        moduleConfig = response.data;
                                    });
                                });
                            }
                        }
                        p = p.then(function () {
                            if (!moduleConfig) {
                                return;
                            }
                            var errors = [];
                            _(actionType.required_config).each(function (data, param) {
                                if (moduleConfig[param] && data.allow_empty === false && !moduleConfig[param].value) {
                                    errors.push('<strong>' + moduleConfig[param].label + '</strong> should not be empty');
                                }
                            });
                            if (!errors.length) {
                                return;
                            }
                            var dialogParams = {
                                'title': 'Invalid Configuration',
                                'message': 'Current configuration doesn\'t allow to perform this action.<br />' + errors.join('<br />')
                            };
                            if (moduleToConfigure) {
                                dialogParams.okText = 'Configure';
                                dialogParams.cancelText = 'Cancel';
                            } else {
                                dialogParams.cancelClass = { 'display-none': true };
                            }
                            modals.confirm(dialogParams).then(function () {
                                if (moduleToConfigure) {
                                    return appConfigurator.configureApp(moduleToConfigure).then(function (response) {
                                        if ($scope.model.entityData && $scope.model.entityData.moduleConfig) {
                                            $scope.model.entityData.moduleConfig = response.data;
                                        }
                                    });
                                }
                            });
                            return $q.reject();
                        });
                    }
                    p.then(function () {
                        return modals.params([{
                                params: _(actionType.attributes).map(function (param) {
                                    return $.extend(true, {}, param);
                                }),
                                lastPage: true,
                                getProperties: _.memoize(remediationProperties(objectTypes.data.sources(logic.entityType)))
                            }], actionType.label, actionType.size, { noDataLabel: actionType.confirm });
                    }).then(function (data) {
                        var body = {
                            name: action.actionType,
                            attributes: data,
                            additionalAction: action.additionalAction
                        };
                        manualActionDao.create(logic.entityType, fileId, body).then(function () {
                            widgetPolling.emit('remediationActionPerformed', body);
                        });
                    });
                };
            });
        };
    }]);
}());